import { InjectionToken } from '@angular/core';

export const VisualizersConfig: InjectionToken<any> = new InjectionToken('visualizers-config');



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/tokens/visualizers-config.token.ts